<template>
  <div class="flex px-5" style="gap: 10px">
    <div class="w-full flex flex-col relative">
      <div class="flex flex-row justify-end p-4" style="gap: 10px">
        <audio id="LogAudioPlayer">
                Your browser does not support the audio element.
              </audio>
        <div @click="changeMicrophone" :class="{ 'hidden': this.isMicrophone }">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="36" height="36" rx="18" fill="#1C1C1C" fill-opacity="0.1" />
            <path
              d="M23.3361 24.3696C23.238 24.4588 23.1085 24.5053 22.976 24.499C22.8436 24.4927 22.7191 24.434 22.6299 24.3359L20.6974 22.2109C20.0363 22.637 19.2828 22.8987 18.4999 22.974V24.9996C18.4999 25.1322 18.4472 25.2594 18.3534 25.3532C18.2597 25.4469 18.1325 25.4996 17.9999 25.4996C17.8673 25.4996 17.7401 25.4469 17.6463 25.3532C17.5526 25.2594 17.4999 25.1322 17.4999 24.9996V22.9746C16.2672 22.8492 15.1247 22.2711 14.2935 21.3521C13.4623 20.4332 13.0014 19.2387 12.9999 17.9996C12.9999 17.867 13.0526 17.7398 13.1463 17.6461C13.2401 17.5523 13.3673 17.4996 13.4999 17.4996C13.6325 17.4996 13.7597 17.5523 13.8534 17.6461C13.9472 17.7398 13.9999 17.867 13.9999 17.9996C14.001 19.0601 14.4228 20.0769 15.1727 20.8268C15.9226 21.5766 16.9394 21.9984 17.9999 21.9996C18.7073 22.0017 19.4024 21.8144 20.013 21.4571L19.3193 20.6946C18.8618 20.9186 18.3549 21.0225 17.8462 20.9964C17.3376 20.9703 16.8439 20.8151 16.4118 20.5455C15.9797 20.2759 15.6234 19.9007 15.3763 19.4553C15.1293 19.0099 14.9998 18.5089 14.9999 17.9996V15.9427L12.6299 13.3359C12.5426 13.2374 12.4976 13.1086 12.5046 12.9772C12.5117 12.8458 12.5703 12.7225 12.6676 12.634C12.765 12.5455 12.8933 12.499 13.0248 12.5045C13.1562 12.51 13.2802 12.5671 13.3699 12.6634L23.3699 23.6634C23.459 23.7615 23.5056 23.891 23.4993 24.0235C23.4929 24.1559 23.4342 24.2804 23.3361 24.3696ZM21.8243 20.424C21.8924 20.4578 21.9675 20.4753 22.0436 20.4752C22.1373 20.4752 22.2291 20.4489 22.3085 20.3993C22.388 20.3497 22.4519 20.2788 22.493 20.1946C22.8285 19.5117 23.002 18.7605 22.9999 17.9996C22.9999 17.867 22.9472 17.7398 22.8534 17.6461C22.7597 17.5523 22.6325 17.4996 22.4999 17.4996C22.3673 17.4996 22.2401 17.5523 22.1463 17.6461C22.0526 17.7398 21.9999 17.867 21.9999 17.9996C22.0017 18.6082 21.8631 19.2089 21.5949 19.7552C21.5366 19.8743 21.5281 20.0117 21.5711 20.1371C21.6141 20.2625 21.7052 20.3657 21.8243 20.424ZM20.1161 18.5977C20.1811 18.6692 20.2654 18.7204 20.3588 18.745C20.4522 18.7696 20.5508 18.7666 20.6426 18.7364C20.7343 18.7062 20.8154 18.6501 20.8759 18.5748C20.9364 18.4994 20.9738 18.4082 20.9836 18.3121C20.9943 18.2083 20.9997 18.104 20.9999 17.9996V13.9996C20.9991 13.3106 20.7612 12.6428 20.3261 12.1085C19.891 11.5742 19.2852 11.206 18.6106 11.0658C17.936 10.9255 17.2337 11.0217 16.6217 11.3383C16.0096 11.6548 15.5252 12.1724 15.2499 12.804C15.2114 12.8923 15.1993 12.9898 15.2149 13.0848C15.2306 13.1798 15.2733 13.2683 15.338 13.3396L20.1161 18.5977Z"
              fill="#414141" />
          </svg>
        </div>


        <div @click="changeMicrophone" :class="{ 'hidden': !this.isMicrophone }">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="36" height="36" rx="18" fill="#EE6D6D" fill-opacity="0.05" />
            <path
              d="M15 18V14C15 13.2044 15.3161 12.4413 15.8787 11.8787C16.4413 11.3161 17.2044 11 18 11C18.7956 11 19.5587 11.3161 20.1213 11.8787C20.6839 12.4413 21 13.2044 21 14V18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21C17.2044 21 16.4413 20.6839 15.8787 20.1213C15.3161 19.5587 15 18.7956 15 18ZM23 18C23 17.8674 22.9473 17.7402 22.8536 17.6464C22.7598 17.5527 22.6326 17.5 22.5 17.5C22.3674 17.5 22.2402 17.5527 22.1464 17.6464C22.0527 17.7402 22 17.8674 22 18C22 19.0609 21.5786 20.0783 20.8284 20.8284C20.0783 21.5786 19.0609 22 18 22C16.9391 22 15.9217 21.5786 15.1716 20.8284C14.4214 20.0783 14 19.0609 14 18C14 17.8674 13.9473 17.7402 13.8536 17.6464C13.7598 17.5527 13.6326 17.5 13.5 17.5C13.3674 17.5 13.2402 17.5527 13.1464 17.6464C13.0527 17.7402 13 17.8674 13 18C13.0015 19.2391 13.4625 20.4336 14.2937 21.3525C15.1249 22.2715 16.2673 22.8496 17.5 22.975V25C17.5 25.1326 17.5527 25.2598 17.6464 25.3536C17.7402 25.4473 17.8674 25.5 18 25.5C18.1326 25.5 18.2598 25.4473 18.3536 25.3536C18.4473 25.2598 18.5 25.1326 18.5 25V22.975C19.7327 22.8496 20.8751 22.2715 21.7063 21.3525C22.5375 20.4336 22.9985 19.2391 23 18Z"
              fill="#EE6D6D" />
          </svg>
        </div>

        <div @click="changeSpeaker" :class="{ 'hidden': this.isSpeaker == 0 }">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="36" height="36" rx="18" fill="#EE6D6D" fill-opacity="0.05" />
            <path
              d="M20 12.0157V23.9807C20.0015 24.0703 19.9798 24.1587 19.937 24.2373C19.8941 24.316 19.8317 24.3822 19.7556 24.4295C19.6692 24.4809 19.5693 24.505 19.469 24.4988C19.3686 24.4926 19.2725 24.4562 19.1931 24.3945L15.095 21.207C15.0653 21.1835 15.0413 21.1536 15.0248 21.1195C15.0084 21.0854 14.9999 21.048 15 21.0101V14.9901C15.0001 14.9521 15.0089 14.9146 15.0257 14.8805C15.0425 14.8464 15.0668 14.8165 15.0969 14.7932L19.195 11.6057C19.2848 11.5362 19.3956 11.4992 19.5093 11.501C19.6229 11.5029 19.7325 11.5433 19.82 11.6157C19.8775 11.6651 19.9234 11.7266 19.9545 11.7957C19.9856 11.8648 20.0012 11.94 20 12.0157ZM13.75 15.0001H12C11.7348 15.0001 11.4804 15.1055 11.2929 15.293C11.1054 15.4806 11 15.7349 11 16.0001V20.0001C11 20.2653 11.1054 20.5197 11.2929 20.7072C11.4804 20.8948 11.7348 21.0001 12 21.0001H13.75C13.8163 21.0001 13.8799 20.9738 13.9268 20.9269C13.9737 20.88 14 20.8164 14 20.7501V15.2501C14 15.1838 13.9737 15.1202 13.9268 15.0733C13.8799 15.0265 13.8163 15.0001 13.75 15.0001ZM21.6731 16.3026C21.6238 16.346 21.5834 16.3987 21.5544 16.4577C21.5254 16.5167 21.5084 16.5808 21.5042 16.6464C21.5 16.712 21.5088 16.7778 21.5301 16.84C21.5513 16.9022 21.5847 16.9596 21.6281 17.0089C21.8693 17.2828 22.0023 17.6352 22.0023 18.0001C22.0023 18.3651 21.8693 18.7175 21.6281 18.9914C21.5835 19.0404 21.549 19.0979 21.5268 19.1604C21.5046 19.2228 21.495 19.2891 21.4987 19.3554C21.5023 19.4216 21.5191 19.4864 21.548 19.5461C21.577 19.6058 21.6175 19.6591 21.6672 19.703C21.717 19.7468 21.775 19.7803 21.8378 19.8016C21.9006 19.8228 21.9671 19.8313 22.0332 19.8267C22.0994 19.822 22.1639 19.8042 22.2232 19.7743C22.2824 19.7444 22.3351 19.7031 22.3781 19.6526C22.7803 19.1961 23.0022 18.6085 23.0022 18.0001C23.0022 17.3917 22.7803 16.8042 22.3781 16.3476C22.3347 16.2982 22.282 16.2577 22.2229 16.2287C22.1639 16.1997 22.0997 16.1826 22.034 16.1784C21.9684 16.1742 21.9025 16.183 21.8403 16.2043C21.778 16.2257 21.7206 16.2591 21.6712 16.3026H21.6731ZM24.2287 14.667C24.1857 14.6156 24.1328 14.5733 24.0731 14.5428C24.0134 14.5122 23.9482 14.494 23.8813 14.4891C23.8145 14.4843 23.7473 14.493 23.6839 14.5146C23.6204 14.5363 23.5619 14.5704 23.512 14.6151C23.462 14.6598 23.4215 14.7141 23.3929 14.7748C23.3644 14.8354 23.3483 14.9012 23.3457 14.9682C23.343 15.0352 23.3539 15.1021 23.3776 15.1648C23.4013 15.2275 23.4374 15.2848 23.4837 15.3332C24.1398 16.0666 24.5025 17.0161 24.5025 18.0001C24.5025 18.9841 24.1398 19.9336 23.4837 20.667C23.4374 20.7155 23.4013 20.7728 23.3776 20.8355C23.3539 20.8982 23.343 20.965 23.3457 21.032C23.3483 21.099 23.3644 21.1648 23.3929 21.2255C23.4215 21.2861 23.462 21.3404 23.512 21.3851C23.5619 21.4298 23.6204 21.464 23.6839 21.4856C23.7473 21.5073 23.8145 21.5159 23.8813 21.5111C23.9482 21.5063 24.0134 21.488 24.0731 21.4575C24.1328 21.4269 24.1857 21.3847 24.2287 21.3332C25.0486 20.4166 25.5018 19.2299 25.5018 18.0001C25.5018 16.7703 25.0486 15.5837 24.2287 14.667Z"
              fill="#EE6D6D" />
          </svg>
        </div>

        <div @click="changeSpeaker" :class="{ 'hidden': this.isSpeaker == 1 }">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="36" height="36" rx="18" fill="#1C1C1C" fill-opacity="0.1" />
            <path
              d="M23.37 23.1639C23.4151 23.2123 23.4501 23.2692 23.473 23.3313C23.496 23.3933 23.5064 23.4593 23.5036 23.5254C23.5008 23.5915 23.485 23.6564 23.4569 23.7164C23.4289 23.7763 23.3893 23.8301 23.3403 23.8746C23.2913 23.9191 23.234 23.9534 23.1717 23.9756C23.1094 23.9978 23.0432 24.0074 22.9772 24.0038C22.9111 24.0003 22.8464 23.9837 22.7868 23.9549C22.7272 23.9262 22.6739 23.8859 22.63 23.8364L20 20.9432V23.9807C20.0015 24.0703 19.9798 24.1587 19.937 24.2373C19.8941 24.316 19.8317 24.3822 19.7556 24.4295C19.6692 24.4809 19.5693 24.505 19.469 24.4988C19.3686 24.4926 19.2725 24.4562 19.1931 24.3945L15.0963 21.207C15.0665 21.1838 15.0423 21.1541 15.0257 21.1202C15.009 21.0863 15.0002 21.0491 15 21.0114V15.4432L12.63 12.8364C12.5849 12.7879 12.5499 12.731 12.527 12.669C12.504 12.6069 12.4936 12.5409 12.4964 12.4748C12.4992 12.4087 12.515 12.3438 12.5431 12.2839C12.5711 12.2239 12.6107 12.1702 12.6597 12.1257C12.7087 12.0812 12.766 12.0468 12.8283 12.0246C12.8906 12.0024 12.9568 11.9929 13.0228 11.9964C13.0889 12 13.1536 12.0166 13.2132 12.0453C13.2728 12.0741 13.3261 12.1144 13.37 12.1639L23.37 23.1639ZM21.6694 19.6976C21.7688 19.7854 21.8989 19.8301 22.0312 19.8218C22.1636 19.8136 22.2872 19.7532 22.375 19.6539C22.7772 19.1973 22.999 18.6098 22.999 18.0014C22.999 17.393 22.7772 16.8054 22.375 16.3489C22.3324 16.2971 22.2798 16.2545 22.2203 16.2235C22.1609 16.1925 22.0958 16.1738 22.029 16.1685C21.9621 16.1631 21.8949 16.1713 21.8313 16.1925C21.7677 16.2136 21.709 16.2474 21.6587 16.2917C21.6084 16.336 21.5675 16.39 21.5385 16.4504C21.5094 16.5108 21.4929 16.5765 21.4897 16.6435C21.4866 16.7104 21.4969 16.7773 21.5202 16.8402C21.5434 16.9031 21.5791 16.9607 21.625 17.0095C21.8662 17.2834 21.9992 17.6358 21.9992 18.0007C21.9992 18.3657 21.8662 18.7181 21.625 18.992C21.5373 19.0915 21.4928 19.2217 21.5011 19.354C21.5094 19.4863 21.5699 19.6099 21.6694 19.6976ZM24.2269 14.667C24.1839 14.6156 24.1309 14.5733 24.0712 14.5428C24.0116 14.5122 23.9463 14.494 23.8795 14.4891C23.8126 14.4843 23.7454 14.493 23.682 14.5146C23.6185 14.5363 23.5601 14.5704 23.5101 14.6151C23.4601 14.6598 23.4196 14.7141 23.3911 14.7748C23.3625 14.8354 23.3464 14.9012 23.3438 14.9682C23.3411 15.0352 23.352 15.1021 23.3757 15.1648C23.3995 15.2275 23.4356 15.2848 23.4819 15.3332C24.1379 16.0666 24.5006 17.0161 24.5006 18.0001C24.5006 18.9841 24.1379 19.9336 23.4819 20.667C23.4356 20.7155 23.3995 20.7728 23.3757 20.8355C23.352 20.8982 23.3411 20.965 23.3438 21.032C23.3464 21.099 23.3625 21.1648 23.3911 21.2255C23.4196 21.2861 23.4601 21.3404 23.5101 21.3851C23.5601 21.4298 23.6185 21.464 23.682 21.4856C23.7454 21.5073 23.8126 21.5159 23.8795 21.5111C23.9463 21.5063 24.0116 21.488 24.0712 21.4575C24.1309 21.4269 24.1839 21.3847 24.2269 21.3332C25.0467 20.4166 25.4999 19.2299 25.4999 18.0001C25.4999 16.7703 25.0467 15.5837 24.2269 14.667ZM19.5625 17.492C19.5963 17.5303 19.641 17.5574 19.6906 17.5695C19.7402 17.5816 19.7923 17.5783 19.84 17.5599C19.8876 17.5415 19.9285 17.509 19.9571 17.4667C19.9857 17.4244 20.0007 17.3743 20 17.3232V12.0157C20.0012 11.94 19.9856 11.8648 19.9545 11.7957C19.9234 11.7266 19.8775 11.6651 19.82 11.6157C19.7325 11.5433 19.6229 11.5029 19.5093 11.501C19.3956 11.4992 19.2848 11.5362 19.195 11.6057L16.4894 13.7082C16.4622 13.7294 16.4397 13.756 16.4232 13.7863C16.4068 13.8165 16.3968 13.8499 16.3939 13.8842C16.3909 13.9186 16.3951 13.9531 16.4062 13.9858C16.4172 14.0184 16.4349 14.0484 16.4581 14.0739L19.5625 17.492ZM13.75 15.0001H12C11.7348 15.0001 11.4804 15.1055 11.2929 15.293C11.1054 15.4806 11 15.7349 11 16.0001V20.0001C11 20.2653 11.1054 20.5197 11.2929 20.7072C11.4804 20.8948 11.7348 21.0001 12 21.0001H13.75C13.8163 21.0001 13.8799 20.9738 13.9268 20.9269C13.9737 20.88 14 20.8164 14 20.7501V15.2501C14 15.1838 13.9737 15.1202 13.9268 15.0733C13.8799 15.0265 13.8163 15.0001 13.75 15.0001Z"
              fill="#414141" />
          </svg>
        </div>
      </div>
      <!-- <hr v-if="radioList.length > 2" class="absolute w-full" style="left: 0; top: 50%; transform: translateY(-50%)" /> -->
      <div v-for="(r, index) in radioList" >
          <div id="video-container" style="position: relative" class="">
            <video :id="`live-video-${r.value}`" class="w-full border border-gray-300 rounded-lg mb-4" :controls="r.isOn" type="video/mp4"
              style="position: relative; z-index: 99"></video>
            <div v-if="r.status === 'loading'" class="absolute"
              style="top: 50%; left: 50%; transform: translate(-50%, -50%)">
              {{ r.label }}
            </div>
            <div v-if="r.status === 'error'" class="absolute" style="
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 100;
            ">
              DVR is not online,
              <a href="#" @click="reloadVideo(index)">click here</a> to reload
            </div>
          </div>
          <div class="flex mb-2 flex-row justify-between w-full" style="gap: 10px">
            <div class="flex flex-row">
              <label for="" class="w-16"> {{ r.label }}</label>
              <template v-if="r.countdown">
                <vue-countdown-timer :start-time="r.countdown.start" :end-time="r.countdown.end" :interval="1000"
                  :start-label="'Until start:'" label-position="begin" :end-text="'Event ended!'"
                  :seconds-txt="'seconds remaining'">
                  <template slot="countdown" slot-scope="scope">
                    <!-- <span>{{ scope.props.hours }}</span
                  ><i>{{ scope.props.hourTxt }}</i>
                  <span>{{ scope.props.minutes }}</span
                  ><i>{{ scope.props.minutesTxt }}</i> -->
                    <div class="flex flew-row items-center" style="gap: 5px">
                      <span class="mb-3">({{ scope.props.seconds }})</span>
                      <span>
                        <vs-tooltip color="#4F4F4F"
                          text="Pembatasan waktu dilakukan untuk menghindari penggunaan data yang berlebihan."
                          position="bottom">
                          <feather-icon icon="HelpCircleIcon" class="cursor-pointer" style="
                            width: 15px;
                            height: 15px;
                            color: #616161;
                          "></feather-icon>
                        </vs-tooltip>
                      </span>
                    </div>
                  </template>
                </vue-countdown-timer>
              </template>
            </div>

            <div class="custom-switch" :class="{'active': r.isOn}" @click="r.isOn = !r.isOn">
              <div class="switch-circle"></div>
            </div>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
import FlvJs from 'flv.js'
import moment from 'moment'
import { cameraUrl } from '../../constant'
import * as REPO from '../../repository/index'
import '../../../public/lib/recorder-core'
import "../../../public/lib/g711x";
import "../../../public/lib/wav";

export default {
  name: 'MonitoringCamera',
  props: {
    license_plate: String,
    dashcam: String,
  },
  data() {
    return {
      status: 'loading',
      camType: 'stoncam',
      radioList: [],
      deviceId: '',
      radios1: '0',
      flvPlayer: null,
      intercome: false,
      isMicrophone: false,
      isSpeaker: 0,
    }
  },
  watch: {
    // dashcam: function (val) {
    //
    // },
    radios1: function (val) {
      this.reloadVideo()
    },
  },
  computed: {
    activeList() {
      return this.radioList.filter((item) => item.isOn)
    },
  },
  created() {
    this.isSpeaker = 0;
    const dc = JSON.parse(this.dashcam)

    this.camType = dc.type
    this.deviceId = dc.device_id
    const channelTmp = dc.channels.map((item, index) => {
      return {
        label: `CH 0${index + 1}`,
        value: index,
        isOn: false,
        status: 'loading',
        flvPlayer: null,
        isOnline: false,
        countdown: null,
      }
    })
    this.radioList = channelTmp
    this.radioList.forEach((item, index) => {
      this.$watch(
        () => item.isOn,
        (val) => {
          if (val) {
            this.startVideo(index)
          } else {
            this.destroyVideo(index)
          }
        }
      )
    })
  },
  mounted() {
    if (FlvJs.isSupported()) {
      //   this.loadingStart('#video-container')
      // this.startVideo()
    } else {
    }

  },
  beforeDestroy() {
    if (this.flvPlayer) {
      this.flvPlayer.unload()
      this.flvPlayer.detachMediaElement()
      this.flvPlayer.destroy()
    }
  },
  methods: {
    // Fungsi untuk memuat script eksternal
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    },
    loadingStart(val) {
      this.$vs.loading({
        container: `${val}`,
        scale: 0.45,
      })
    },
    loadingStop(val) {
      this.$vs.loading.close(`${val} > .con-vs-loading`)
    },
    async startVideo(index) {
      const obj = this.radioList[index]
      const videoElement = document.getElementById(`live-video-${obj.value}`)

      let url = ''



      if (this.camType === 'STONKAM') {
        url = `${cameraUrl}/OpenDeviceStream/100?DeviceId=${this.deviceId}&ChannelId=${obj.value}&RealTime=1&SessionId=1071`
      } else {
        const token = await REPO.getMettaXToken().then((res) => {
          //
          return res.data.data
        })

        //
        const body = {
          deviceId: this.deviceId,
          channelId: obj.value + 1,
          bitstreamType: 0,
        }
        const hehe = await REPO.mettaXLiveCamera(token, body).then((res) => {
          return res.data
        })

        // 
        // const hehe = await fetch(mettaxiotUrl, {
        //   method: 'POST',
        //   headers: {
        //     Authorization: token,
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify({
        //     deviceId: this.deviceId,
        //     channelId: obj.value + 1,
        //     bitstreamType: 0,
        //   }),
        // }).then((res) => {
        //   return res.json()
        // })
        url = hehe.data
      }

      //
      obj.flvPlayer = FlvJs.createPlayer(
        {
          type: 'flv',
          isLive: true,
          hasAudio: false,
          hasVideo: true,
          // url: `http://35.198.202.131:8082/OpenDeviceStream/100?DeviceId=${this.deviceId}&ChannelId=${obj.value}&RealTime=1&SessionId=1071`,
          url: url,
        },
        {
          enableStashBuffer: false,
        }
      )
      obj.flvPlayer.attachMediaElement(videoElement)
      obj.flvPlayer.on(FlvJs.Events.LOADING_COMPLETE, () => {
        obj.isOnline = true
        // this.loadingStop('#video-container')
      })
      obj.flvPlayer.on(FlvJs.Events.ERROR, (errType, errDetail) => {
        console.error('FLV Error:', errType, errDetail)
        obj.status = 'error'
        obj.isOnline = false
        // this.reloadVideo()
      })
      obj.flvPlayer.load()
      obj.flvPlayer.play()
      const startDate = moment().format('YYYY-MM-DD HH:mm:ss')
      const endDate = moment().add(30, 'seconds').format('YYYY-MM-DD HH:mm:ss')
      const countdown = {
        start: startDate,
        end: endDate,
      }
      obj.countdown = countdown
      const timeout = moment(endDate).diff(moment(startDate))

      setTimeout(() => {
        obj.status = 'loading'
        obj.isOnline = false
        obj.isOn = false
      }, timeout)
    },
    destroyVideo(index) {
      this.radioList[index].flvPlayer.pause()
      this.radioList[index].flvPlayer.unload()
      this.radioList[index].flvPlayer.detachMediaElement()
      this.radioList[index].flvPlayer.destroy()
      this.radioList[index].flvPlayer = null
      this.radioList[index].countdown = null
    },
    reloadVideo(index) {
      this.destroyVideo(index)
      this.status = 'loading'
      this.startVideo(index)
    },
    async pushTalk() {
      const token = await REPO.getMettaXToken().then((res) => {
        //
        return res.data.data
      })

      const body = {
        "channelId": 1,
        "deviceId": this.deviceId,
        "talkChannel": "singapore-1"
      }

      const data = await REPO.mettaXTalkPlus(token, body).then((res) => {

        return res.data.data
      })
      return data


    },
    //Intercome
    async openIntercome() {
      this.intercome = !this.intercome
      if (this.intercome) {
        this.isSpeaker = 1;
        const data = await this.pushTalk()
        this.getSocket(data.talkUrl)
      } else {
        this.isSpeaker = 0;
        this.socket.close();
        this.socket = null;
        if (this.isMicrophone) {
          this.changeMicrophone()
        }
      }

    },
    getSocket(url, callback) {
      // const url = 'wss://m1.mettaxiot.com/talk/websocket/' + imei + '/' + token;
      // const url = url

      let _this = this;

      this.socket = new WebSocket(url);

      this.socket.onopen = function () {
        _this.loading = true;
      };

      this.socket.onmessage = function (msg) {
        if (msg.data instanceof Blob) {
          _this.loading = false;
          _this.receive(msg);
          // _this.socket.send(msg)
        } else if (msg.data === 'repeat') {
          _this.loading = false;
          alert('device busy');
          _this.$message.warning(_this.$t('device busy'));
          callback();
          this.openIntercome();
        } else if (msg.data === 'error') {
          _this.loading = false;
          _this.$message.warning(_this.$t('device error'));
          callback();
        } else if (msg.data.code === 'network') {
          //msg.data :{"deviceTime": "1725976558122",  "serverTime": "1725947758702",  "code": "network"}
          //devicetime uses the device's time zone 
          //serverTime uses 0 time zone
        }
      };

      this.socket.onclose = function (e) {
        _this.loading = false;

      };

      this.socket.onerror = function () {
        _this.loading = false;
      };


    },
    receive(msg) {
      if (typeof msg.data === 'string') {

      }
      if (msg.data instanceof Blob) {

        var audio = document.getElementById('LogAudioPlayer');
        audio.volume = 1;
        if (!(audio.ended || audio.paused)) {
          audio.pause();
        }
        var end = function (blob) {
          const objectURL = (window.URL || window.webkitURL).createObjectURL(blob);
          audio.src = objectURL;

          audio.oncanplaythrough = function () {
            audio.play().catch(error => console.error("Error saat play:", error));
          };
        };

        if (Recorder['g711a2wav']) {
          Recorder['g711a2wav'](
            msg.data,
            function (blob) {
              end(blob);
            },
            function (error) {
              console.error("Konversi G.711A ke WAV gagal:", error);
            }
          );
        } else {
          console.error('Recorder["g711a2wav"] tidak tersedia! Pastikan plugin g711 sudah dimuat.',);
        }

        var wav = Recorder['g711a2wav'];
        if (wav) {
          var wavData = msg.data;
          wav(
            wavData,
            function (blob) {
              end(blob);
            },
            function (msg) {

            }
          );
        } else {

        }
      }
    },
    changeMicrophone() {
      this.isMicrophone = !this.isMicrophone;

      if (this.isMicrophone) {
        this.initRecord();
      } else {
        this.closeRecord();
      }
    },
    async changeSpeaker() {
      this.isSpeaker = this.isSpeaker == 1 ? 0 : 1;
      console.log("this.isSpeaker", this.isSpeaker)
      if (this.isSpeaker == 1) {
        const data = await this.pushTalk()
        this.getSocket(data.talkUrl)
      } else if (this.isSpeaker == 0) {
        this.socket.close();
        this.socket = null;
      }

    },
    initRecord() {
      let _this = this;

      this.record = Recorder({
        type: 'g711a',
        onProcess: function (buffers, powerLevel, bufferDuration, bufferSampleRate) {
          _this.RealTimeSendTry(buffers, bufferSampleRate, false);
        }
      });

      this.record.open(
        function () {


          _this.record.start();
          _this.RealTimeSendTryReset();
        },
        function (msg, isUserNotAllow) {

        }
      );
    },
    closeRecord() {
      if (this.record === null) {
        return;
      }

      this.record.close();
      this.RealTimeSendTry([], 0, true);

      let _this = this;
      this.record.stop(
        function (blob, duration) {
          var newRec = Recorder({ type: 'g711a' });
          var pcm = Recorder.SampleData(_this.record.buffers, _this.record.srcSampleRate, _this.record.srcSampleRate).data;
          newRec.mock(pcm, _this.record.srcSampleRate);

          newRec.stop(function (blob, duration) {
            var audio = document.getElementById('LogAudioPlayer');
            audio.style.display = 'inline-block';
            if (!(audio.ended || audio.paused)) {
              audio.pause();
            }

            var end = function (blob) {
              audio.src = (window.URL || window.webkitURL).createObjectURL(blob);
              audio.play();
            };

            var wav = Recorder['g711a2wav'];
            if (wav) {
              var wavData = blob;
              wav(
                wavData,
                function (blob) {
                  end(blob);
                },
                function (msg) {
                  console.error(msg);
                }
              );
            } else {
              end(blob);
            }
          });
        },
        function (msg) {
          console.info(msg);
        },
        true
      );

      this.record = null;
    },
    RealTimeSendTryReset() {
      this.realTimeSendTryChunks = null;
    },
    RealTimeSendTry(buffers, bufferSampleRate, isClose) {


      let _this = this;
      if (this.realTimeSendTryChunks == null) {
        this.realTimeSendTryNumber = 0;
        this.transferUploadNumberMax = 0;
        this.realTimeSendTryChunk = null;
        this.realTimeSendTryChunks = [];
      }

      if (this.testBitRate == 16 && this.SendFrameSize % 2 == 1) {

        return;
      }

      var pcm = [];
      var pcmSampleRate = 0;
      if (buffers.length > 0) {
        var chunk = Recorder.SampleData(buffers, bufferSampleRate, this.testSampleRate, this.realTimeSendTryChunk);

        for (var i = this.realTimeSendTryChunk ? this.realTimeSendTryChunk.index : 0; i < chunk.index; i++) {
          buffers[i] = null;
        }
        this.realTimeSendTryChunk = chunk;

        pcm = chunk.data;
        pcmSampleRate = chunk.sampleRate;

      }

      if (pcm.length > 0) {
        this.realTimeSendTryChunks.push({ pcm: pcm, pcmSampleRate: pcmSampleRate });
      }

      // var chunkSize = this.SendFrameSize / (this.testBitRate / 8);
      // console.log("ini kenapa",this.SendFrameSize , this.testBitRate , 8)
      var chunkSize = 80000 * 0.5;

      pcm = new Int16Array(chunkSize);
      pcmSampleRate = 0;
      var pcmOK = false;
      var pcmLen = 0;
      for1: for (var i1 = 0; i1 < this.realTimeSendTryChunks.length; i1++) {
        chunk = this.realTimeSendTryChunks[i1];
        pcmSampleRate = chunk.pcmSampleRate;

        for (var i2 = chunk.offset || 0; i2 < chunk.pcm.length; i2++) {
          pcm[pcmLen] = chunk.pcm[i2];
          pcmLen++;

          if (pcmLen == chunkSize) {
            pcmOK = true;
            chunk.offset = i2 + 1;
            for (var i3 = 0; i3 < i1; i3++) {
              this.realTimeSendTryChunks.splice(0, 1);
            }
            break for1;
          }
        }
      }

      if (!pcmOK) {
        if (isClose) {
          var number = ++this.realTimeSendTryNumber;
          this.TransferUpload(number, null, 0, null, isClose);
        }
        return;
      }

      number = ++this.realTimeSendTryNumber;
      var encStartTime = Date.now();

      var recMock = Recorder({
        type: 'g711a',
        sampleRate: this.testSampleRate,
        bitRate: this.testBitRate
      });

      recMock.mock(pcm, pcmSampleRate);
      recMock.stop(
        function (blob, duration) {
          blob.encTime = Date.now() - encStartTime;
          _this.TransferUpload(number, blob, duration, recMock, false);
          _this.RealTimeSendTry([], 0, isClose);
        },
        function (msg) {

        }
      );
    },
    TransferUpload(number, blobOrNull, duration, blobRec, isClose) {
      this.transferUploadNumberMax = Math.max(this.transferUploadNumberMax, number);
      console.log("TransferUpload", isClose)

      if (blobOrNull) {


        var blob = blobOrNull;
        // var encTime = blob.encTime;

        // this.socket.send(blob);
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
          this.socket.send(blob);
        } else {
          console.error("WebSocket belum siap, data tidak dikirim.");
        }
      }
      if (isClose) {

      }
    },
  },
}
</script>

<style lang="scss">
/* Custom Switch Button */
.custom-switch {
  position: relative;
  width: 50px;
  height: 26px;
  background: #6b6b6b;
  border-radius: 13px;
  cursor: pointer;
  transition: background 0.3s ease;
  display: flex;
  align-items: center;
  padding: 2px;

  /* Circle inside switch */
  .switch-circle {
    width: 22px;
    height: 22px;
    background: #ffffff;
    border-radius: 50%;
    transition: all 0.3s ease;
    transform: translateX(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  /* Hover effect */
  &:hover {
    opacity: 0.85;
  }

  /* Active state - GREEN */
  &.active {
    background: #4caf50;

    .switch-circle {
      background: #ffffff;
      transform: translateX(24px);
      box-shadow: 0 2px 6px rgba(76, 175, 80, 0.5);
    }
  }
}
</style>
